/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_LearnInputs */

const en_header_learn = /** @type {(inputs: Header_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn`)
};

/**
* | output |
* | --- |
* | "Learn" |
*
* @param {Header_LearnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header_learn = /** @type {((inputs?: Header_LearnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_LearnInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_learn(inputs)
});